import ActionButton, {
    ActionButtonProps,
} from '@deltek/specification-client/core/Buttons/ActionButton'
import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { makeStyles, Theme } from '@material-ui/core/styles'
import clsx from 'clsx'
import React from 'react'

export const baseActionButtonStyles = makeStyles((theme: Theme) => ({
    baseButton: {
        '& .actionButtonContainer > button': {
            borderRadius: 50,
            fontSize: pxToRem(18),
            paddingLeft: theme.spacing(2.5),
            paddingRight: theme.spacing(2.5),
            paddingTop: 10,
            paddingBottom: 10,
            lineHeight: '21px',
        },
    },
}))

const blueActionButtonStyles = makeStyles((theme: Theme) => ({
    blueButtonContainer: {
        '& .actionButtonContainer > button': {
            boxShadow: 'unset',
            color: '#04325B',
            border: '1px solid',
            '&:hover': {
                color: '#fff',
                backgroundColor: '#04325B',
            },
            '&.Mui-disabled': {
                color: '#b3b3b3',
            },
        },
    },
}))

export interface BlueActionButtonProps {
    additionalClassName?: string
    actionButtonProps?: ActionButtonProps
}

export const BlueActionButton: React.FC<BlueActionButtonProps> = ({
    additionalClassName,
    actionButtonProps,
    children,
}) => {
    const baseActionButtonClasses = baseActionButtonStyles()
    const blueActionButtonClasses = blueActionButtonStyles()
    return (
        <div
            className={clsx(
                baseActionButtonClasses.baseButton,
                blueActionButtonClasses.blueButtonContainer,
                additionalClassName
            )}
        >
            <ActionButton color="secondary" {...actionButtonProps}>
                {children}
            </ActionButton>
        </div>
    )
}
